import React, { useEffect } from 'react';
import './Individual.css';
import L from 'leaflet';
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Locations() {
  const location = useLocation()
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Locations Page' });
    let map = null; // Declare map variable outside of useEffect

    // Function to initialize map
    const initializeMap = () => {
        // Check if map container already exists
        if (map !== null) {
            // Remove existing map instance
            map.remove();
        }

        // Initialize map
        map = L.map('map').setView([0, 25], 3);

        // Tile layer from OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
        }).addTo(map);

         // Country locations and names
        var countries = [
          { 
              name: ("<h4 style='color: green;'>Kenya</h4><p style='color: black;'>At a Glance<br>&#8226; 115,000+ acres impacted <br>&#8226; 850+ individuals employed from underserved communities<br>1. The Great Rift Valley - Kijabe Forest : -1.053487, 36.645037 <br>&#8226; Provides habitat for wildlife, sustainable economic opportunities for local communities <br>2. Northern coast - Lamu County : -2.151584, 40.795936 <br>&#8226; Mangrove and coastal forest habitats</p>"),
              latlng: [-1.053487, 36.645037] 
          },
          { 
              name: ("<h4 style='color: green;'>Madagascar</h4><p style='color: black;'>At a Glance<br>&#8226; 105,000+ acres impacted<br>&#8226; 3,480+ individuals employed in underserved communities<br>1. Coastal - Northwest Madagascar<br>&#8226; Mangrove reforestation<br>&#8226; Over two million mangroves planted per month<br>&#8226; Protected natural reserves & parks<br>2. Ankarafantsika National Park<br>&#8226; Home to eight species of endangered lemurs<br>&#8226; 70% of the 820 species of plants found in the park are endemic to Madagascar</p>"),
              latlng: [-15.360702, 47.222570]
          },
          { 
              name: ("<h4 style='color: green;'>Mozambique</h4><p style='color: black;'>At a Glance<br>&#8226; 282,000+ acres impacted<br> &#8226; 1,255+ individuals employed from underserved communities<br>Coastal - Maputo Bay : -25.921572, 32.681633<br>&#8226; Mangrove restoration and reforestation</p>"),
              latlng: [-25.921572, 32.681633] 
          },
          { 
              name: ("<h4 style='color: green;'>Ethiopia</h4><p style='color: black;'>At a Glance<br>&#8226; 6000+ acres impacted<br>&#8226; 5+ individuals employed from underserved communities<br>Dawuro zone - Omo Valley of Ethiopia<br>&#8226; Riverine forests and highland peaks restoration<br>&#8226; An agroforestry program to promote food security</p>"),
              latlng: [9.1450, 40.4897] 
          },
          { 
              name: ("<h4 style='color: green;'>Indonesia</h4><p style='color: black;'>At a Glance<br>&#8226; 2,360+ hectares<br>&#8226; 5+ individuals<br>employed in underserved geographies<br>&#8226; Coastal - Biak Island : -1.105133, 135.890019</p>"),
              latlng: [-0.7893, 113.9213] 
          },
          { 
              name: ("<h4 style='color: green;'>Haiti</h4><p style='color: black;'>At a Glance<br>1. Coastal - Southern Haiti : 18.232055, -72.294779<br>&#8226; Mangrove reforestation and restoration project<br>2. Inland - Southeast Haiti : 18.901996, -72.040806<br>&#8226; Planting agroforestry species to promote food security</p>"),
              latlng: [18.9712, -72.2852] 
          },
          { 
              name: ("<h4 style='color: green;'>Philippines</h4><p style='color: black;'>At a Glance<br>&#8226; 39,000+ acres impacted<br>&#8226; 85+ individuals employed from underserved communities employed from underserved geographies<br>1. Bukidnon - Kibuwa Site: 8.243720, 125.042223<br>&#8226; Preserving terrestrial forest and montane rainforest on indigenous land<br>2. Misamis Oriental - Canitoan-Pagatpat Site : 8.461966, 124.572649<br>&#8226; Implementing agroforestry techniques to promote food security<br>&#8226; Protecting the forests and communities from logging</p>"),
              latlng: [12.8797, 121.7740] 
          },
          { 
              name: ("<h4 style='color: green;'>Honduras</h4><p style='color: black;'>At a Glance<br>&#8226; 27,000+ acres impacted<br>&#8226; 120+ individuals<br>employed in underserved communities<br>&#8226; La Tigra National Park : 14.202657, -87.123883</p>"),
              latlng: [15.1997, -86.2419] 
          },
          { 
              name: ("<h4 style='color: green;'>Nepal</h4><p style='color: black;'>At a Glance<br>&#8226; 16,000+ acres impacted<br>&#8226; 190+ individuals employed from underserved communities<br>1. Western Himalayan Mountains – Nawalparasi : 27.644977, 83.864543<br>&#8226; New trees in deforested areas to anchor the soil and protect the villages from environmental disasters<br>2. SE Grasslands - Jhapa : 26.430887, 87.742759<br>&#8226; Restore previously forested land in the region<br>3. Chitwan National Park : 27.533246, 84.452155<br>&#8226; Tropical and subtropical forests in Nepal's first national park</p>"),
              latlng: [28.3949, 84.1240] 
          },
        ];

        // Check if countries array is not empty
        if (countries.length > 0) {
            // Add pins to the map
            countries.forEach(country => {
                const marker = L.marker(country.latlng).addTo(map);
                marker.bindPopup(`<b>${country.name}</b>`).openPopup();
            });

            // Calculate bounds only if countries array is not empty
            const bounds = new L.LatLngBounds();
            countries.forEach(country => {
                bounds.extend(country.latlng);
            });

            // Check if bounds are valid
            if (!bounds.isValid()) {
                console.error('Bounds are not valid.');
                return;
            }

            // Center the map on the average coordinates of the countries
            map.fitBounds(bounds);
        } else {
            console.warn('Countries array is empty.');
        }
    };

    // Call the initializeMap function when component mounts
    initializeMap();

    // Cleanup function to remove map instance when component unmounts
    return () => {
        if (map !== null) {
            map.remove();
        }
    };
  }, []);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Locations</title>
      </Helmet>
      <div style={{paddingTop: '3%', margin: 'auto 3%'}} className="flex">
        <h1 style={{color: 'green', textAlign: 'center', marginTop: '1%', marginBottom: '2%'}}>Our Project Locations</h1>
      </div>
      <div id="map" style={{height: '400px'}} />
      {/* Back to Top */}
      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up" /></a>
    </div>
  );
}

export default Locations;